import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { reactErrorHandler } from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Silence console.warn and console.error in production builds
// Development mode keeps full logging
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.warn = noop;
  console.error = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Workbox service worker (alongside Firebase messaging SW)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Auto-update on new version
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "activated" && navigator.serviceWorker.controller) {
                // New version available — will activate on next page load
              }
            });
          }
        });
      })
      .catch(() => {});
  });
}
